import { render, staticRenderFns } from "./QResourceMenuCorporate.vue?vue&type=template&id=41b2df32&"
import script from "./QResourceMenuCorporate.vue?vue&type=script&lang=js&"
export * from "./QResourceMenuCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports